import './styles.scss';
import { useAuth, useSigninCheck } from 'reactfire';
import CMSHome from '../CMSHome/';
import CMSLogin from '../CMSLogin/';
import {checkUser} from '../../../functions/emailWhitelist';
import CMSUnauthorized from '../CMSUnauthorized/';
export default function CMSAuth(props) {
  const auth = useAuth()
  const signedIn = useSigninCheck()
  let content = 'loading...'
  if (signedIn.data) {
    if (signedIn.data.signedIn) {
      const whitelisted = checkUser(auth)
      if (whitelisted) {
        content = <CMSHome />
      } else {
        content = <CMSUnauthorized />
      }
    } else {
      content = <CMSLogin {...props} />
    }
  }
  return (
    <div className='CMSAuth'>
      {content}
    </div>
  )
}
